import { render, staticRenderFns } from "./RegisterEventMember.vue?vue&type=template&id=1af0c06e&"
import script from "./RegisterEventMember.vue?vue&type=script&lang=js&"
export * from "./RegisterEventMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports